import React from 'react';

import Dropdown from "./ReactDropdown";

export default class ReactDropdownAchievementGroupsWithNotifications extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	//
	// defaultItemId : The user ID of the user to select, if supplied
	// user_id : The user ID of the ESW or user who is calling this
	
	static get defaultProps() 
	{
	    var v =
	    	{
		    	  defaultValue: 0,
		    	  value: 0,
				  valueLookup: 'byValue'
	    	} ;

	    	return v ;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 1 ;

		let v = 0 ;

		if ( this.props.defaultValue != null )
		{
			v = this.props.defaultValue ;
		}

    	// Create a state item here
		this.state = { 
			currentValue: v,
			valid: this.isValueValid(this.props.value),
			items: null,
			dirty: false,
			loading: true 
		};
	}
	
	componentDidMount()
	{				
		this.getdata () ;		
	}
	
	componentWillUnmount()
	{
      this.setState({isMounted: false})
  	}

	componentDidUpdate(prevProps, prevState)
	{
		// If the value changed externally
		if ( this.props.defaultValue != prevProps.defaultValue)
		{
			this.setState ( { currentValue: this.props.defaultValue}) ;
		}
	}

	getValue()
	{
		return this.state.currentValue ;
	}
	
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}

	getdata( )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var url = root + "/achievementgroups"
		
    	$.ajax({
    		  type: 'GET',
    		  url: url,
    		  data: { },
    		  success:(data)=>{

    		  	let list = data.data ;

    		  	// Append the please select option
			    list.push( { achievement_group_desc: 'Please pick an achievement area', achievement_group_id: 0 } ) ;

				this.setState({  dirty: false, loading: false , items: list });
    			    				
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
		  		}
    		});
	}

	findValueText ( value )
	{
		for (let i = 0; i < this.state.items.length; i++)
		{
			if ( this.state.items[i].achievement_group_id  == value )
			{
				return this.state.items[i].achievement_group_desc ;
			}
		}

		return '' ;
	}

	handleChange(e) 
	{
		let val = e.target.value ;

		let text = this.findValueText ( val ) ;

		if ( this.props.onChange != null )
		{
			this.props.onChange ( value );
		}

		this.sendChangeNotification() ;

		this.setState ( {dirty: true, currentValue: val} ) ;
	}

	returnOption ( row )
	{
		return React.createElement ( 'option', {key: this.keyCount++, name: row.achievement_group_id, value: row.achievement_group_id} , row.achievement_group_desc ) ;
	}

	optionList ()
	{
		return this.state.items.map(element =>
		{
			return this.returnOption ( element ) ;
		});
	}

	dropdown_select ( id )
	{
		return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, className: 'form-control', id: id , tabIndex: this.props.tabIndex, onChange: this.handleChange.bind(this)}, this.optionList() ) ;
	}

	render()
    {
    	if ( this.state.loading == true )
    	{
			return this.optionDropdownLoading();
    	}
    	else
    	{
			if ( this.props.readOnly != 'readonly' )
			{
				return React.createElement ( 'div', {key: this.keyCount++, className: 'input-group'}, this.optionDropdown('list999')) ;
			}
			else
			{
				return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
			}
    	}
	}
};


